import { render } from "./beautyClassify.vue?vue&type=template&id=02db2258&scoped=true"
import script from "./beautyClassify.vue?vue&type=script&lang=js"
export * from "./beautyClassify.vue?vue&type=script&lang=js"

import "./beautyClassify.vue?vue&type=style&index=0&id=02db2258&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02db2258"]])

export default __exports__